import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import TrashModal from '../../../components/modals/trashModal';
import RecoverModal from '../../../components/modals/recoverModal';
import AddModal from '../../../components/modals/addModal';
import EditModal from '../../../components/modals/editModal';
import DeleteModal from '../../../components/modals/deleteModal';
import ViewModal from '../../../components/modals/viewModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';

import { FaPlus } from "react-icons/fa";
import { selectStyles } from '../../../components/dropDown/selectStyle';
import AsyncSelect from 'react-select/async';

import Loader from '../../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, StockMovementtypeFormatter } from '../../../components/formatters/defFormatter';
import { quantityInFormatter, quantityOutFormatter } from '../../../components/formatters/defFormatter';

import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";

import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";



import { DataContext } from '../../../init/getData';
import { TbDeviceAudioTape } from 'react-icons/tb';
import AsyncDropDownFilter from '../../../components/filters/asyncDropdownFilter';




function StockMovement(props) {

  let { } = props;


  const { userData, settingData, api, warehouseData, refData, selectedCompany, selectedYear, productData, devData, contentLanguages } = useContext(DataContext);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [loadingCounter, setLoadingCounter] = useState(0);

  const createdBy = parseInt(userData.id);
  const userRole = userData.role;
  const defaultwarehouseId = userData.role.defaultwarehouseId;
  const companyId = selectedCompany.id;
  const yearId = selectedYear.id;

  const fromDate = selectedYear?.year + '-01-01';
  const toDate = selectedYear?.year + '-12-31';

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);

  const [filter, setFilter] = useState({ search: '', fromDate: fromDate, toDate: toDate, productId: null, companyId: companyId, yearId: yearId });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);


  const [name, setName] = useState('');
  const [category, setCategory] = useState([]);

  const table = 'StockMovement';
  const title = 'Stock Activity';


  //Get Data 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['warehouse', 'product']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  // warehouse Options
  const warehouseOptions = warehouseData?.map(item => ({
    value: item.id,
    label: item.name,
  }))


  const selectedWarehouse = warehouseOptions.filter(option => option.value === filter.warehouseId);

  const inStockProducts = productData.filter(product => (product.type !== 'production' && product.isStock));

  // Product Options
  const productOptions = inStockProducts?.map(item => ({
    value: item.id,
    label: `${item.sku ? ` (${item.sku}) ` : ''}  ${item.name} ${item.barcode ? ` [${item.barcode}]` : ''}`,
    unit: item.unit,
  }))

  // Load and filter account options
  const loadProductOptions = (inputValue, callback) => {
    const filteredOptions = inputValue ? productOptions.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
    callback(filteredOptions);
  };

  const selectedProduct = productOptions.find(option => option.value === filter.productId);


  const addModal = () => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }

  const resetForm = () => {
    setCategory({ createdBy: createdBy })
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  // idRow Change
  useEffect(() => {
    setCategory(
      {
        name: idRow?.name || '',
        createdBy: createdBy,
      }
    )
  }, [idRow]);


  
  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e.transaction?.journalVoucher);
    }
    setShowViewModal(!showViewModal);
  }




  //Excel Data
  const getExcelData = (data, getSummary) => {
    const transformedData = data.map(item => ({
      ID: item.id,
      "JV-ID": item.transaction?.journalVoucher?.id,
      Date: item.transaction?.journalVoucher?.date,
      Product: item.product?.name,
      Type: item.transaction?.journalVoucher?.type,
      "Total In": item.transaction?.isDebit ? item.netQuantity * item.unitQuantity : 0,
      "Total Out": !item.transaction?.isDebit ? Math.abs(item.netQuantity * item.unitQuantity) : 0,
      Cost: numberFormatter(item.cost),
      Warehouse: item.transaction?.warehouse?.name,
      Details: item.transaction?.details,
      User: item.transaction?.created?.name,
      Cum: item.cumulativeQuantity
    }));

    return { transformedData };
  };


  let newColumnDefs = [
    { title: contentLanguages.JvId, dataIndex: 'transaction', render: (transaction) => (transaction?.journalVoucher?.id), width: '4%' },
    { title: contentLanguages.Date, dataIndex: 'transaction', render: (transaction) => (transaction?.journalVoucher?.date), width: '8%' },
    { title: contentLanguages.Product, dataIndex: 'product', render: (product) => (product?.name), width: '10%' },
    { title: contentLanguages.Type, dataIndex: 'transaction', render: (transaction) => (transaction?.journalVoucher?.type), width: '10%' },
    { title: contentLanguages.TotalIn, dataIndex: 'netQuantity', width: '8%', render: quantityInFormatter },
    { title: contentLanguages.TotalOut, dataIndex: 'netQuantity', width: '8%', render: quantityOutFormatter },
    { title: contentLanguages.Cost, dataIndex: 'netCost', render: numberFormatter },
    { title: contentLanguages.Warehouse, dataIndex: 'transaction', render: (transaction) => (transaction?.warehouse?.name) },
    { title: contentLanguages.Details, dataIndex: 'transaction', render: (transaction) => (transaction?.details) },
    { title: contentLanguages.User, dataIndex: 'transaction', render: (transaction) => (transaction?.created?.name) },
    { title: contentLanguages.Cumulative, dataIndex: 'cumulativeQuantity' },
    {
      title: contentLanguages.View,
      width: '8%',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <FcViewDetails size={20} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
        </div>
      ),
    }
  ];


  useEffect(() => {

    setColumnDefs(newColumnDefs);

  }, []);


  const formView = (
    <div style={{ userSelect: 'none' }}>
    </div >);




  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (

    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
      <div>
        <span className='table-footer footer-green'>Total In: {numberFormatter(data?.summary?.totalIn, 2)} {selectedProduct?.unit}</span>
        <span className='table-footer footer-red'>Total Out: {numberFormatter(data?.summary?.totalOut, 2)} {selectedProduct?.unit}</span>
        <span className='table-footer footer-one'>Quantity: {numberFormatter(data?.summary?.totalIn - data?.summary?.totalOut, 2)} {selectedProduct?.unit}</span>
      </div>
    </div>

  );


  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  };


  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>

          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={3}>
              <DatePicker setFilter={setFilter} filter={filter} />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={warehouseOptions}
                isSearchable={true}
                isClearable={true}
                onChange={(e) => handleSelectChange(e, 'warehouseId')}
                value={warehouseOptions?.find(option => option.value === filter.warehouseId) || []}
                placeholder={'Select Warehouse ... '}
                required
              />
            </Col>

            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                cacheOptions
                isClearable={true}
                loadOptions={loadProductOptions}
                defaultOptions={[]}
                onChange={(e) => handleSelectChange(e, 'productId')}
                value={productOptions?.find(option => option.value === filter.productId)}
                noOptionsMessage={() => 'type to view'}
                placeholder={'Select Product ... '}
              />
            </Col>

            <Col md={1}>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>







          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
            height={true}
          />



          {viewModal &&
            <ViewModal
              showModal={showViewModal}
              toggleModal={viewModal}
              journalVoucherId={idRow.id}
            />
          }


        </>
      }

    </div>
  )
}

export default StockMovement;
